// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"74":"IconsTest","268":"Home","615":"WebShop","732":"News","768":"App"}[chunkId] || chunkId) + "." + {"74":"37b3002f","199":"9c668517","268":"f8fb3fd1","323":"5301720c","615":"96c7c076","732":"835114f1","768":"9733098a","787":"cf4c0533"}[chunkId] + ".chunk.js";
};